import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import {
  jurisdictionMessages,
  type JurisdictionMessageKey,
} from './jurisdiction.messages';

interface SubdivisionLike {
  code: string;
  name: string;
}

export const getJurisdictionMessageKey = (
  code: string
): JurisdictionMessageKey | null => {
  const key = code.replace(/-/g, '_') as JurisdictionMessageKey;
  return key in jurisdictionMessages ? key : null;
};

export const useLocalizedSubdivisionName = () => {
  const intl = useIntl();

  return useCallback(
    (subdivision: SubdivisionLike) => {
      const messageKey = getJurisdictionMessageKey(subdivision.code);
      if (messageKey) {
        return intl.formatMessage(jurisdictionMessages[messageKey]);
      }
      return subdivision.name;
    },
    [intl]
  );
};
